var CirculosHorizontales = function(el, datos, total, callback) {
  var debug = false;
  var config = new Config(220, { top: 70, right: 10, bottom: 60, left: 10 });

  var margin = config.getMargin();
  var medidas = config.getMedidas();

  var gMargin = config.getGMargin();
  var gMedidas = config.getGMedidas();

  var circulos = config.getCirculos();

  var contenedor = null;
  var svg = null;
  var gGrafica = null;

  var grupos = null;

  function setup() {
    contenedor = d3.select(el[0]);
    var flag = el.data("visualizacion") || false;
    if (flag === false) {
      el.data("visualizacion", true);
      contenedor.selectAll("svg").remove();
      svg = contenedor
        .append("svg")
        .attr("preserveAspectRatio", "xMidYMid")
        .attr(
          "viewBox",
          "0 0 " +
            (medidas.ancho + margin.left + margin.right) +
            " " +
            (medidas.alto + margin.top + margin.bottom)
        );

      el.attr("data-setup", true);

      if (debug === true) {
        svg
          .append("rect")
          .attr("fill", "yellow")
          .attr("opacity", 0.5)
          .attr("x", 0)
          .attr("y", 0)
          .attr("width", medidas.ancho + margin.left + margin.right)
          .attr("height", medidas.alto + margin.top + margin.bottom);
      }

      svg = svg
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      if (debug === true) {
        svg
          .attr("class", "svg")
          .append("rect")
          .attr("width", medidas.ancho + (margin.right - margin.left))
          .attr("height", medidas.alto)
          .attr("fill", "blue")
          .attr("opacity", 0.5);
      }

      gGrafica = svg
        .append("g")
        .attr(
          "transform",
          "translate(" + gMargin.left + "," + gMargin.top + ")"
        );

      if (debug === true) {
        gGrafica
          .attr("class", "gGrafica")
          .append("rect")
          .attr("width", gMedidas.ancho)
          .attr("height", gMedidas.alto)
          .attr("fill", "red")
          .attr("opacity", 0.5);
      }

      main();
    }
  }

  function main() {
    setCirculos();
    funciones.generaTooltips(gGrafica.selectAll("path.transporte"));
    el.removeClass("espera");
    iniciar();
  }

  function revisaScroll() {
    if (el.visible() === true) {
      iniciar();
      $(window).off("scroll", revisaScroll);
    }
  }

  function iniciar() {
    actualizaCirculos();
    callback(null, true);
  }

  function actualizaCirculos() {
    var prefijo = el.data("prefijo") || "";
    var unidad = el.data("unidad") || "";
    var divisor = el.data("divisor") || 1;

    grupos
      .append("text")
      .attr("x", 0)
      .attr("y", 0)
      .style(circulos.estiloTexto)
      .attr("opacity", 0)
      .text(function(d) {
        if (unidad == "%") {
          var v = parseInt(d.valor);
          if (v < 1) {
            v = "<1";
          }
          return prefijo + v + unidad;
        }
        return prefijo + parseInt(+d.valor / divisor) + unidad;
      })
      .transition()
      .duration(800)
      .attr("opacity", 1);
  }

  function setCirculos() {
    var n = datos.extras.length - 1;
    var xIni = (gMedidas.ancho - n * circulos.distanciaHorizontal) / 2;

    var unidad = el.data("unidad") || "";

    var flagAjustar = el.attr("data-recalcular-total") || false;

    if (flagAjustar !== false) {
      total = _.sumBy(datos.opciones, "valor");
    }

    if (unidad == "%") {
      var pcts = funciones.getPorcentajes(_.map(datos.extras, "valor"), total);
      _.each(pcts, function(p, i) {
        datos.extras[i].valor = pcts[i];
      });
    }

    grupos = gGrafica
      .selectAll("g.circulo")
      .data(datos.extras, function(d) {
        return d.opcion;
      })
      .enter()
      .append("g")
      .attr("class", "circulo")
      .attr("transform", function(d, i) {
        return "translate(" + (xIni + i * circulos.distanciaHorizontal) + ",0)";
      });

    grupos
      .append("circle")
      .attr("cx", 0)
      .attr("cy", 0)
      .attr("r", circulos.radio)
      .style(circulos.estiloCirculo);

    grupos
      .append("text")
      .style(circulos.estiloLeyenda)
      .attr("y", gMedidas.alto + 20)
      .text(function(d) {
        return d.etiqueta;
      })
      .call(funciones.wrap, circulos.radio * 3);
  }

  setup();
};
